import React, { useState, useContext, useCallback, useRef, useEffect } from 'react';

import PresentPC from 'components/pages/AddInput/PresentPC';
import PresentSP from 'components/pages/AddInput/PresentSP';
import {
  useWindowDimensions,
  useDirectTransCheck,
  useIECheck,
  sortErrors,
  isSchemaValid,
  isCustomValid,
  isFatalApiError,
  changeStr,
  scrollTop,
  MoveCheckStart,
  MoveCheckStop,
} from 'utils';
import { getHourSalaryApi, postLeaveWithoutOrderApi } from 'utils/api';
import { CHOICES_MAP, CHOICES_NAME_MAP, ADD_INPUT_CONF_TITLE, MEASURE_MAP, LP_URL, COMMENT_MAP } from 'utils/constant';
import MeasureEvent from 'utils/measureEvent';

import AppContext from 'fluxes/context';
import { UPDATE_ADD_INPUT, REGISTER, CHANGE_VALID } from 'fluxes/actions';

const AddInput = () => {
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);
  const {
    ekiCd,
    companyNameText,
    receiptID,
    clickID,
    mediaID,
    isRegisteredLeaveWithoutOrder
  } = state;
  const [ howToDo, setHowToDo ] = useState('01');
  const [ floatingBanner, setFloatingBanner] = useState('');
  const [ workInfoContent, setWorkInfoContent ] = useState(state.workInfoContent);
  const [ skillLevel, setSkillLevel ] = useState(state.skillLevel);
  const [ hourSalaryMin, setHourSalaryMin ] = useState(
    state.hourSalaryMin,
  );
  const [ hourSalaryMax, setHourSalaryMax ] = useState(
    state.hourSalaryMax,
  );
  const [ suggestHourSalary, setSuggestHourSalary ] = useState(
    state.suggestHourSalary,
  );
  const [ skillLevelExcel, setSkillLevelExcel ] = useState(state.skillLevelExcel);
  const [ skillLevelPowerpoint, setSkillLevelPowerpoint ] = useState(
    state.skillLevelPowerpoint,
  );
  const [ bgdOfRecruitment, setBgdOfRecruitment ] = useState(state.bgdOfRecruitment);
  const [ workEnvi, setWorkEnvi ] = useState(state.workEnvi);
  const [ workStyle, setWorkStyle ] = useState(state.workStyle);
  const [ overTime, setOverTime ] = useState(state.overTime);
  const [ startTime, setStartTime ] = useState(state.startTime);
  const [ endTime, setEndTime ] = useState(state.endTime);
  const [ desiredStartDateKubun, setDesiredStartDateKubun ] = useState(
    state.desiredStartDateKubun,
  );
  const [ desiredStartDate, setDesiredStartDate ] = useState(
    state.desiredStartDate ? new Date(state.desiredStartDate) : '',
  );
  const [ workPeriod, setWorkPeriod ] = useState(state.workPeriod);

  const [ showLoading, setShowLoading ] = useState(false);
  const [ workDetailText, setWorkDetailText ] = useState(state.workDetailText);
  const [ workInfoContentCmnt, setWorkInfoContentCmnt ] = useState(state.workDetailText);
  const [ skillOtherCmnt, setSkillOtherCmnt ] = useState(state.skillOtherCmnt);
  const [ bgdOfRecruitmentCmnt, setBgdOfRecruitmentCmnt ] = useState(state.bgdOfRecruitmentCmnt);
  const [ workStyleCmnt, setWorkStyleCmnt ] = useState(state.workStyleCmnt);
  const [ startTimeCmnt, setStartTimeCmnt ] = useState(state.startTimeCmnt);
  const [ endTimeCmnt, setEndTimeCmnt ] = useState(state.endTimeCmnt);
  const [ workPeriodCmnt, setWorkPeriodCmnt ] = useState(state.workPeriodCmnt);

  const [remoteWork, setRemoteWork] = useState(state.remoteWork);
  const [remoteWorkCount, setRemoteWorkCount] = useState(state.remoteWorkCount);
  const [holidayWork, setHolidayWork] = useState(state.holidayWork);
  const [timeSavingAva, setTimeSavingAva] = useState(state.timeSavingAva);
  const [useCar, setUseCar] = useState(state.useCar);
  const [smokeEnvi, setSmokeEnvi] = useState(state.smokeEnvi);
  const [welfare, setWelfare] = useState(state.welfare);

  const [isScroll, setIsScroll] = useState(false);

  // レスポンシブ
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  // 直接遷移チェック
  useDirectTransCheck({ state });
  MoveCheckStart();

  // 派遣依頼登録 クリア
  useEffect(() => {
    dispatch({ type: REGISTER });
  }, [ dispatch ]);

  // 入力チェック用変数
  const initialValid = { valid: state.validMap[path], errorMessages: [] };
  const [ valids, setValids ] = useState({
    schema: initialValid,
  });

  // 初期入力チェック設定
  const [ isShowError, setIsShowError ] = useState({
    workInfoContent: false,
    skillLevel: false,
    bgdOfRecruitment: false,
    workStyle: false,
    startTime: false,
    endTime: false,
    overTime: false,
    desiredStartDateKubun: false,
    workPeriod: false,
    workInfoContentCmnt: false,
    skillOtherCmnt: false,
    bgdOfRecruitmentCmnt: false,
    workStyleCmnt: false,
    startTimeCmnt: false,
    endTimeCmnt: false,
    workPeriodCmnt: false,
    remoteWork: false,
    remoteWorkCount: false,
    holidayWork: false,
    timeSavingAva: false,
    useCar: false,
    smokeEnvi: false,
    welfare: false,
  });

  const [ isApiError, setIsApiError ] = useState(false);

  const dispErrors = useCallback(() => {
    const { schema } = valids;
    const errors = sortErrors([
      ...schema.errorMessages,
    ]);
    const errorMap = errors.reduce((obj, error) => {
      const { target, message } = error;
      if(!isShowError[target] || Object.keys(obj).includes(target)) return obj;
      return { ...obj, [target]: message };
    }, {});
    console.log({ errorMap });
    return errorMap;
  }, [ isShowError, valids ]);

  // 入力チェック（全体）
  useEffect(()=> {
    const [ isValid, newErrorMessages ] = isSchemaValid({
      target: {
        workInfoContent,
        skillLevel,
        bgdOfRecruitment,
        workStyle,
        startTime,
        endTime,
        overTime,
        desiredStartDateKubun,
        workPeriod,
        workInfoContentCmnt,
        skillOtherCmnt,
        bgdOfRecruitmentCmnt,
        workStyleCmnt,
        startTimeCmnt,
        endTimeCmnt,
        workPeriodCmnt,
        remoteWork,
        remoteWorkCount,
        holidayWork,
        timeSavingAva,
        useCar,
        smokeEnvi,
        welfare,
      },
    });

    console.log('valid:schema', { isValid, newErrorMessages });
    console.log(`valid out vaid schema ${ valid}`);
    // erros更新
    const newValid = { schema: { valid: isValid, errorMessages: newErrorMessages } };
    setValids(org => ({ ...org, ...newValid }));
  }, [
    workInfoContent,
    skillLevel,
    bgdOfRecruitment,
    workStyle,
    startTime,
    endTime,
    overTime,
    desiredStartDateKubun,
    workPeriod, 
    workInfoContentCmnt,
    skillOtherCmnt,
    bgdOfRecruitmentCmnt,
    workStyleCmnt,
    startTimeCmnt,
    endTimeCmnt,
    workPeriodCmnt,
    remoteWork,
    remoteWorkCount,
    holidayWork,
    timeSavingAva,
    useCar,
    smokeEnvi,
    welfare,
  ]);

  /**
   * 画面スクロール
  */
  const workInfoRef = useRef(null);
  const workConditionsRef = useRef(null);

  const handleScroll = () => {
    // イベント計測
    MeasureEvent(
      {
        linkTrackVars: MEASURE_MAP.EVENT_82.linkTrackVars,
        linkTrackEvents: MEASURE_MAP.EVENT_82.linkTrackEvents,
        events: MEASURE_MAP.EVENT_82.events,
      },
      MEASURE_MAP.EVENT_82.name,
    );
    const position = window.pageYOffset;
    if (position == 0) {
      setIsScroll(false);
      setFloatingBanner('');
    } else {
      setIsScroll(true);

      if (workConditionsRef.current && workConditionsRef.current) {
        if (workInfoRef.current.getBoundingClientRect().top < 370 && workInfoRef.current.getBoundingClientRect().bottom > 370) {
          setFloatingBanner('01');
        } else if (workConditionsRef.current.getBoundingClientRect().top < 370 && workConditionsRef.current.getBoundingClientRect().bottom > 370) {
          setFloatingBanner('02');
        }
      }
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const floatingBannerScrollEvent = (banner) => {
    // イベント計測
    MeasureEvent(
      {
        linkTrackVars: MEASURE_MAP.EVENT_82.linkTrackVars,
        linkTrackEvents: MEASURE_MAP.EVENT_82.linkTrackEvents,
        events: MEASURE_MAP.EVENT_82.events,
      },
      MEASURE_MAP.EVENT_82.name,
    );
    let scrollTop = '';
    switch (banner) {
      case '01':
        scrollTop = document.getElementById('workInfo').getBoundingClientRect().top;
        break;
      case '02':
        scrollTop = document.getElementById('workConditions').getBoundingClientRect().top;
        break;
      default:
        break;
    }
    window.scrollTo({ top: scrollTop + window.pageYOffset, behavior: 'smooth' });
  };

  /**
   * 共通メソッド
   */
  // 請求金額計算
  const calcHourSalary = (hourSalary, level) => {
    let result = [];
    switch (level) {
      case '01':
        result = [ hourSalary - 100, hourSalary ];
        break;

      case '02':
        result = [ hourSalary, hourSalary + 100 ];
        break;

      case '03':
        result = [ hourSalary + 100, hourSalary + 200 ];
        break;

      default:
        break;
    }
    return result;
  };

  /**
   * 初期処理
   */
  useEffect(()=>{
    if (workInfoContentCmnt.trim()) {
      setWorkInfoContent([ ...workInfoContent, COMMENT_MAP.workInfoContentCmnt.value ]);
    }
  }, []);

  useEffect(()=>{
    const params = { ekiCd };
    const getHourSalary = async () => {
      setShowLoading(true);
      const hourSalary = await getHourSalaryApi({ params }).catch(err => {
        // FATELエラーチェック
        const isFatal = isFatalApiError(err);
        setIsApiError(isFatal);
        if(isFatal) throw err;
        return 0;
      });
      setSuggestHourSalary(hourSalary);
      setShowLoading(false);
      return hourSalary;
    };
    getHourSalary();

    const initialLevel = '01';
    setSkillLevel(initialLevel);
    const resHourSalary = calcHourSalary(suggestHourSalary, initialLevel);
    setHourSalaryMin(resHourSalary[0]);
    setHourSalaryMax(resHourSalary[1]);
    setSkillLevelExcel(initialLevel);
    setSkillLevelPowerpoint(initialLevel);
  }, [ ekiCd, suggestHourSalary ]);

  /**
   * onChange作成
   */
  const howToDoOnChange = (e) => {
    const val = e.target.value;
    setHowToDo(val);
  };
  const workInfoContentOnChange = (e) => {
    const val = e.target.value;
    if (workInfoContent.includes(e.target.value)) {
      if (workInfoContent.includes(COMMENT_MAP.workInfoContentCmnt.value)) {
        setWorkInfoContentCmnt(workDetailText);
      }
      setWorkInfoContent(workInfoContent.filter((item) => item !== val));
    } else {
      setWorkInfoContent([ ...workInfoContent, val ]);
    }
  };
  const skillLevelOnChange = (e) => {
    const val = e.target.value;
    setSkillLevel(val);
    const resHourSalary = calcHourSalary(suggestHourSalary, val);
    setHourSalaryMin(resHourSalary[0]);
    setHourSalaryMax(resHourSalary[1]);
    setSkillLevelExcel(val);
    setSkillLevelPowerpoint(val);
  };
  const workEnviOnChange = (e) => {
    const val = e.target.value;
    if (workEnvi.includes(e.target.value)) {
      setWorkEnvi(workEnvi.filter((item) => item !== val));
    } else {
      setWorkEnvi([ ...workEnvi, val ]);
    }
  };
  const bgdOfRecruitmentOnChange = (e) => {
    setBgdOfRecruitment(e.target.value);
    setBgdOfRecruitmentCmnt('');
  };
  const workStyleOnChange = (e) => {
    setWorkStyle(e.target.value);
    setWorkStyleCmnt('');
  };
  const overTimeOnChange = (e) => {
    setOverTime(e.target.value);
  };
  const startTimeOnChange = (e) => {
    setStartTime(e.target.value);
    setStartTimeCmnt('');
  };
  const endTimeOnChange = (e) => {
    setEndTime(e.target.value);
    setEndTimeCmnt('');
  };
  const desiredStartDateOnChange = (e) => {
    if (e.target.value === '01') {
      setDesiredStartDate();
      setDesiredStartDateKubun(e.target.value);
    }
  };
  const handleChangeDate = (e, val) => {
    const date = new Date(
      `${String(e).slice(0, 4)}/${String(e).slice(4, 6)}/${String(e).slice(6)}`,
    );
    setDesiredStartDate(changeStr(date));
    setDesiredStartDateKubun(val);
  };
  const workPeriodOnChange = (e) => {
    setWorkPeriod(e.target.value);
    setWorkPeriodCmnt('');
  };

  const onChangeWorkInfoContentCmnt = (e) => {
    setWorkInfoContentCmnt(e.target.value);
    if(!isShowError.workInfoContentCmnt) {
      setIsShowError({ ...isShowError, workInfoContentCmnt: true });
    }
  };
  const onChangeSkillOtherCmnt = (e) => {
    setSkillOtherCmnt(e.target.value);
    if(!isShowError.skillOtherCmnt) {
      setIsShowError({ ...isShowError, skillOtherCmnt: true });
    }
  };
  const onChangeBgdOfRecruitmentCmnt = (e) => {
    setBgdOfRecruitmentCmnt(e.target.value);
    if(!isShowError.bgdOfRecruitmentCmnt) {
      setIsShowError({ ...isShowError, bgdOfRecruitmentCmnt: true });
    }
  };
  const onChangeWorkStyleCmnt = (e) => {
    setWorkStyleCmnt(e.target.value);
    if(!isShowError.workStyleCmnt) {
      setIsShowError({ ...isShowError, workStyleCmnt: true });
    }
  };
  const onChangeStartTimeCmnt = (e) => {
    setStartTimeCmnt(e.target.value);
    if(!isShowError.startTimeCmnt) {
      setIsShowError({ ...isShowError, startTimeCmnt: true });
    }
  };
  const onChangeEndTimeCmnt = (e) => {
    setEndTimeCmnt(e.target.value);
    if(!isShowError.endTimeCmnt) {
      setIsShowError({ ...isShowError, endTimeCmnt: true });
    }
  };
  const onChangeWorkPeriodCmnt = (e) => {
    setWorkPeriodCmnt(e.target.value);
    if(!isShowError.workPeriodCmnt) {
      setIsShowError({ ...isShowError, workPeriodCmnt: true });
    }
  };
  const remoteWorkOnChange = (e) => {
    setRemoteWork(e.target.value);
    setRemoteWorkCount("");
  };
  const remoteWorkCountOnChange = (e) => {
    setRemoteWorkCount(e.target.value);
  };
  const holidayWorkOnChange = (e) => {
    setHolidayWork(e.target.value);
  };
  const timeSavingAvaOnChange = (e) => {
    setTimeSavingAva(e.target.value);
  };
  const useCarOnChange = (e) => {
    setUseCar(e.target.value);
  };
  const smokeEnviOnChange = (e) => {
    setSmokeEnvi(e.target.value);
  };
  const welfareOnChange = (e) => {
    const val = e.target.value;
    if(val === '09'){
      // 該当なし以外を消す
      if (welfare.includes(val)) {        
        setWelfare([]);
      } else {
        setWelfare([ '09' ]);
      }
    } else {
      // 該当なしを消す
      if(welfare.includes('09')){
        setWelfare(welfare.splice(welfare.indexOf('09'), 1));
      }
      if (welfare.includes(val)) {
        setWelfare(welfare.filter(item => item !== val));
      } else {
        setWelfare([ ...welfare, val ]);
      }
    }
  };

  const floatingBannerOnChange = (e) => {
    const val = e.target.value;
    setFloatingBanner(val);
    floatingBannerScrollEvent(val);
  };

  /**
   * 表示用画面項目作成
   */
  const howToDoAreaDisp = {
    bigTitle: 'ご依頼を受け付けました',
    headTitle: 'この後の進め方を以下の２つから選択してください',
    howToDoList: CHOICES_MAP.howToDo.map((elem, index) => {
      return {
        value: elem.value,
        label: elem.label,
        subLabel: elem.subLabel,
        point: elem.point,
        id: elem.value,
        onChange: howToDoOnChange,
        checked: howToDo === elem.value,
        icon: index === 0 ? 'icon_sentaku2' : 'icon_sentaku1',
      };
    }),
  };

  const workInfoContentDips = {
    title: '業務内容',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.workInfoContentList.map((elem) => {
      const infoStr = 'workInfoContent';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: workInfoContentOnChange,
        checked: workInfoContent.includes(elem.value),
      };
    }),
    type: 'BasicCheckBoxInput',
    comment: {
      title: COMMENT_MAP.workInfoContentCmnt.title,
      visible: workInfoContent.includes(COMMENT_MAP.workInfoContentCmnt.value),
      label: CHOICES_NAME_MAP.notShow,
      questionMark: true,
      popUpTitle: COMMENT_MAP.workInfoContentCmnt.popUpTitle,
      popUpDetail: COMMENT_MAP.workInfoContentCmnt.popUpDetail,
      relativePosArrow: '75%',
      name: 'workInfoContentCmnt',
      textAreaValue: workInfoContentCmnt,
      cmntOnChange: onChangeWorkInfoContentCmnt,
      onInput: onChangeWorkInfoContentCmnt,
      onCompositionEnd: onChangeWorkInfoContentCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      errMessage: dispErrors().workInfoContentCmnt,
    },
  };

  const skillLevelDips = {
    title: '希望するスキルレベルを教えてください',
    label: CHOICES_NAME_MAP.require,
    subTitle:
      '記載スキルは参考となります。ご紹介するスタッフによってスキルが異なりますのでご了承ください。',
    list: CHOICES_MAP.skillLevelList.map((elem, index) => {
      const infoStr = 'skillLevel';
      const resHourSalary = calcHourSalary(suggestHourSalary, elem.value);
      return {
        value: elem.value,
        id: infoStr + elem.value,
        onChange: skillLevelOnChange,
        name: infoStr,
        checked: skillLevel ? skillLevel.includes(elem.value) : index === 0,
        level: elem.label,
        salary: `${resHourSalary[0]}~${resHourSalary[1]}円/時間`,
        skill: [
          `Excel：${CHOICES_MAP.skillLevelExcelList[index].label}`,
          `PowerPoint：${CHOICES_MAP.skillLevelPowerpointList[index].label}`,
        ],
      };
    }),
    type: 'SkillLevel',
  };
  const skillOtherDip = {
    title: COMMENT_MAP.skillOtherCmnt.title,
    label: CHOICES_NAME_MAP.notShow,
    questionMark: true,
    popUpTitle: COMMENT_MAP.skillOtherCmnt.popUpTitle,
    popUpDetail: COMMENT_MAP.skillOtherCmnt.popUpDetail,
    subTitle: COMMENT_MAP.skillOtherCmnt.subTitle,
    list: CHOICES_MAP.skillOtherList.map((elem) => {
      const infoStr = 'skillOtherCmnt';
      return {
        name: infoStr,
        value: skillOtherCmnt,
        onChange: onChangeSkillOtherCmnt,
        onInput: onChangeSkillOtherCmnt,
        onCompositionEnd: onChangeSkillOtherCmnt,
        maxLength: '500',
        wordCount: '(500文字以下)',
        inValid: true,
      };
    }),
    type: 'TextAreaInput',
    errorDispMessages: dispErrors().skillOtherCmnt,
  };

  const bgdOfRecruitmentDisp = {
    title: '募集背景を教えてください',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.bgdOfRecruitmentList.map((elem) => {
      const infoStr = 'bgdOfRecruitment';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: bgdOfRecruitmentOnChange,
        checked: bgdOfRecruitment.includes(elem.value),
        name: infoStr,
        number: 3,
      };
    }),
    type: 'RadioInput',
    isLine: false,
    comment: {
      title: COMMENT_MAP.bgdOfRecruitmentCmnt.title,
      visible: bgdOfRecruitment.includes(COMMENT_MAP.bgdOfRecruitmentCmnt.value),
      label: CHOICES_NAME_MAP.notShow,
      questionMark: false,
      popUpTitle: COMMENT_MAP.bgdOfRecruitmentCmnt.popUpTitle,
      popUpDetail: COMMENT_MAP.bgdOfRecruitmentCmnt.popUpDetail,
      name: 'bgdOfRecruitmentCmnt',
      textAreaValue: bgdOfRecruitmentCmnt,
      cmntOnChange: onChangeBgdOfRecruitmentCmnt,
      onInput: onChangeBgdOfRecruitmentCmnt,
      onCompositionEnd: onChangeBgdOfRecruitmentCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      errMessage: dispErrors().bgdOfRecruitmentCmnt,
    },
  };

  const workEnviDisp = {
    title: ADD_INPUT_CONF_TITLE.workEnvi,
    label: CHOICES_NAME_MAP.notShow,
    list: CHOICES_MAP.workEnviList.map((elem) => {
      const infoStr = 'workEnvi';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: workEnviOnChange,
        checked: workEnvi.includes(elem.value),
      };
    }),
    type: 'CheckBoxInput',
  };

  const workStyleDisp = {
    title: '勤務形態',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.workStyleList.map((elem) => {
      const infoStr = 'workStyle';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: workStyleOnChange,
        checked: workStyle.includes(elem.value),
        name: infoStr,
        number: 3,
      };
    }),
    type: 'RadioInput',
    comment: {
      title: COMMENT_MAP.workStyleCmnt.title,
      visible: workStyle.includes(COMMENT_MAP.workStyleCmnt.value),
      label: CHOICES_NAME_MAP.notShow,
      questionMark: true,
      popUpTitle: COMMENT_MAP.workStyleCmnt.popUpTitle,
      popUpDetail: COMMENT_MAP.workStyleCmnt.popUpDetail,
      name: 'workStyleCmnt',
      textAreaValue: workStyleCmnt,
      cmntOnChange: onChangeWorkStyleCmnt,
      onInput: onChangeWorkStyleCmnt,
      onCompositionEnd: onChangeWorkStyleCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      errMessage: dispErrors().workStyleCmnt,
    },
  };

  const startTimeDisp = {
    title: '始業時間',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.startTimeList.map((elem) => {
      const infoStr = 'startTime';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: startTimeOnChange,
        checked: startTime.includes(elem.value),
        name: infoStr,
        number: 4,
      };
    }),
    type: 'RadioInput',
    comment: {
      title: COMMENT_MAP.startTimeCmnt.title,
      visible: startTime.includes(COMMENT_MAP.startTimeCmnt.value),
      label: CHOICES_NAME_MAP.notShow,
      questionMark: true,
      popUpTitle: COMMENT_MAP.startTimeCmnt.popUpTitle,
      popUpDetail: COMMENT_MAP.startTimeCmnt.popUpDetail,
      relativePosArrow: '12%',
      name: 'startTimeCmnt',
      textAreaValue: startTimeCmnt,
      cmntOnChange: onChangeStartTimeCmnt,
      onInput: onChangeStartTimeCmnt,
      onCompositionEnd: onChangeStartTimeCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      errMessage: dispErrors().startTimeCmnt,
    },
  };

  const endTimeDisp = {
    title: '終業時間',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.endTimeList.map((elem) => {
      const infoStr = 'endTime';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: endTimeOnChange,
        checked: endTime.includes(elem.value),
        name: infoStr,
        number: 4,
      };
    }),
    type: 'RadioInput',
    comment: {
      title: COMMENT_MAP.endTimeCmnt.title,
      visible: endTime.includes(COMMENT_MAP.endTimeCmnt.value),
      label: CHOICES_NAME_MAP.notShow,
      questionMark: true,
      popUpTitle: COMMENT_MAP.endTimeCmnt.popUpTitle,
      popUpDetail: COMMENT_MAP.endTimeCmnt.popUpDetail,
      relativePosArrow: '12%',
      name: 'endTimeCmnt',
      textAreaValue: endTimeCmnt,
      cmntOnChange: onChangeEndTimeCmnt,
      onInput: onChangeEndTimeCmnt,
      onCompositionEnd: onChangeEndTimeCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      errMessage: dispErrors().endTimeCmnt,
    },
  };

  const overTimeDisp = {
    title: '残業時間',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.overTimeList.map((elem) => {
      const infoStr = 'overTime';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: overTimeOnChange,
        checked: overTime ? overTime.includes(elem.value) : false,
        name: infoStr,
        number: 3,
      };
    }),
    type: 'RadioInput',
  };

  const desiredStartDateDisp = {
    title: '就業開始希望日',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.desiredStartDateKubunList.map((elem, index) => {
      const infoStr = 'desiredStartDate';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: desiredStartDateOnChange,
        handleChange: handleChangeDate,
        checked: desiredStartDateKubun
          ? desiredStartDateKubun.includes(elem.value)
          : false,
        name: infoStr,
        number: 3,
        isCalendarRadio: index !== 0,
      };
    }),
    type: 'RadioInput',
  };

  const workPeriodDisp = {
    title: '就業予定期間',
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.workPeriodList.map((elem) => {
      const infoStr = 'workPeriod';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: workPeriodOnChange,
        checked: workPeriod.includes(elem.value),
        name: infoStr,
        number: 3,
      };
    }),
    type: 'RadioInput',
    comment: {
      title: COMMENT_MAP.workPeriodCmnt.title,
      visible: workPeriod.includes(COMMENT_MAP.workPeriodCmnt.value),
      label: CHOICES_NAME_MAP.notShow,
      questionMark: true,
      popUpTitle: COMMENT_MAP.workPeriodCmnt.popUpTitle,
      popUpDetail: COMMENT_MAP.workPeriodCmnt.popUpDetail,
      relativePosArrow: '85%',
      name: 'workPeriodCmnt',
      textAreaValue: workPeriodCmnt,
      cmntOnChange: onChangeWorkPeriodCmnt,
      onInput: onChangeWorkPeriodCmnt,
      onCompositionEnd: onChangeWorkPeriodCmnt,
      maxLength: '500',
      placeholder: '',
      rows: '10',
      cols: '125',
      wordCount: '(500文字以下)',
      errMessage: dispErrors().workPeriodCmnt,
    },
  };

  const remoteWorkDisp = {
    title: ADD_INPUT_CONF_TITLE.remoteWork,
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.remoteWorkList.map((elem) => {
      const infoStr = 'remoteWork';
      return {
        name: infoStr,
        id: infoStr + elem.value,
        value: elem.value,
        label: elem.label,
        onChange: remoteWorkOnChange,
        checked: remoteWork.includes(elem.value),
        number: 3,
      };
    }),
    type: 'RadioChidInput',
    radioChild: remoteWork.includes("01") ?
      {
        title: ADD_INPUT_CONF_TITLE.remoteWorkCount,
        label: CHOICES_NAME_MAP.require,
        list: CHOICES_MAP.remoteWorkCountList.map((elem) => {
          const infoStr = 'remoteWorkCount';
          return {
            value: elem.value,
            label: elem.label,
            id: infoStr + elem.value,
            onChange: remoteWorkCountOnChange,
            checked: remoteWorkCount.includes(elem.value),
            name: infoStr,
            number: 3,
          };
        }),
        type: 'RadioInput',
        visible: remoteWork.includes("01"),
      }
      : null,
  };

  const holidayWorkDisp = {
    title: ADD_INPUT_CONF_TITLE.holidayWork,
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.holidayWorkList.map((elem) => {
      const infoStr = 'holidayWork';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: holidayWorkOnChange,
        checked: holidayWork.includes(elem.value),
        name: infoStr,
        number: 3,
      };
    }),
    type: 'RadioInput',
  };

  const timeSavingAvaDisp = {
    title: ADD_INPUT_CONF_TITLE.timeSavingAva,
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.timeSavingAvaList.map((elem) => {
      const infoStr = 'timeSavingAva';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: timeSavingAvaOnChange,
        checked: timeSavingAva.includes(elem.value),
        name: infoStr,
        number: 3,
      };
    }),
    type: 'RadioInput',
  };

  const useCarDisp = {
    title: ADD_INPUT_CONF_TITLE.useCar,
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.useCarList.map((elem) => {
      const infoStr = 'useCar';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: useCarOnChange,
        checked: useCar.includes(elem.value),
        name: infoStr,
        number: 3,
      };
    }),
    type: 'RadioInput',
  };

  const smokeEnviDisp = {
    title: ADD_INPUT_CONF_TITLE.smokeEnvi,
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.smokeEnviList.map((elem) => {
      const infoStr = 'smokeEnvi';
      return {
        value: elem.value,
        label: elem.label,
        id: infoStr + elem.value,
        onChange: smokeEnviOnChange,
        checked: smokeEnvi.includes(elem.value),
        name: infoStr,
        number: 3,
      };
    }),
    type: 'RadioInput',
  };

  const welfareDisp = {
    title: ADD_INPUT_CONF_TITLE.welfare,
    label: CHOICES_NAME_MAP.require,
    list: CHOICES_MAP.welfareList.map((elem) => {
      const infoStr = 'welfare';
      return {
        id: infoStr + elem.value,
        value: elem.value,
        label: elem.label,
        onChange: welfareOnChange,
        checked: welfare.includes(elem.value),
        number: 3,
      };
    }),
    type: 'BasicCheckBoxInput',
  };

  const floatingBannerDisp = {
    list: CHOICES_MAP.floatingBanner.map((elem) => {
      return {
        id: 'floatingBanner' + elem.value,
        value: elem.value,
        label: elem.label,
        onChange: floatingBannerOnChange,
        checked: floatingBanner.includes(elem.value),
      };
    }),
    visible: isScroll,
  };

  const returnTopDisp = {
    onClick: scrollTop,
    visible: isScroll,
  };

  const workInfoDips = [
    workInfoContentDips,
    skillLevelDips,
    skillOtherDip,
    workStyleDisp,
    remoteWorkDisp,
    holidayWorkDisp,
    startTimeDisp,
    endTimeDisp,
    overTimeDisp,
    timeSavingAvaDisp,
    desiredStartDateDisp,
    workPeriodDisp,
  ];

  const workConditionsDisp = [
    bgdOfRecruitmentDisp,
    workEnviDisp,
    useCarDisp,
    smokeEnviDisp,
    welfareDisp,
  ];

  // エラーの画面表示で利用する値
  const valid = Object.keys(valids).every((key) => valids[key].valid);

  // 就業開始希望日日付指定チェック
  useEffect(()=>{
    const validation = async () => {
    // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkDesiredStartDate' ],
        target: { desiredStartDate, desiredStartDateKubun },
      });
      console.log('valid:custom:checkDesiredStartDate', { isValid, newErrorMessages });
    
      // erros更新
      const newValid = { checkDesiredStartDate: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ desiredStartDate, desiredStartDateKubun ]);

  // state更新処理
  const updateState = () => {
    dispatch({
      type: UPDATE_ADD_INPUT,
      updAddInput: {
        workInfoContent,
        skillLevel,
        hourSalaryMin: hourSalaryMin.toString(),
        hourSalaryMax: hourSalaryMax.toString(),
        suggestHourSalary,
        skillLevelExcel,
        skillLevelPowerpoint,
        bgdOfRecruitment,
        workEnvi,
        workStyle,
        overTime,
        startTime,
        endTime,
        desiredStartDateKubun,
        desiredStartDate,
        workPeriod,
        workInfoContentCmnt,
        skillOtherCmnt,
        bgdOfRecruitmentCmnt,
        workStyleCmnt,
        startTimeCmnt,
        endTimeCmnt,
        workPeriodCmnt,
        remoteWork,
        remoteWorkCount,
        holidayWork,
        timeSavingAva,
        useCar,
        smokeEnvi,
        welfare,
      },
    });
  };

  // ボタン押下
  const onClickMainButton = {
    prev: (e) => {
      // イベント計測
      MeasureEvent(
        {
          linkTrackVars: MEASURE_MAP.EVENT_83.linkTrackVars,
          linkTrackEvents: MEASURE_MAP.EVENT_83.linkTrackEvents,
          events: MEASURE_MAP.EVENT_83.events,
        },
        MEASURE_MAP.EVENT_83.name,
      );
      updateState();
      scrollTop();
      
      setShowLoading(true);
      const params = {
        companyNameText,
        receiptID,
        clickID,
        mediaID,
      };
      // データ登録処理
      e.preventDefault();
      // 二重登録
      if(isRegisteredLeaveWithoutOrder) {
        setIsApiError(true);
        return false;
      };

      // 更新処理
      postLeaveWithoutOrderApi({ params })
        .then(() => {
          // 直接遷移チェック
          MoveCheckStop();
          // 計測をするため遷移を0.8秒遅らせる
          setTimeout(()=>{
            window.location.href = LP_URL;
          }, 8 * 100);
        }).catch(err => {
          //  オンライン発注追加入力なし離脱 FATELエラーチェック
          const isFatal = isFatalApiError(err);
          setIsApiError(isFatal);
          if(isFatal) throw err;
        
          // 400エラーは基本的に起きないためFATAL
          if(err.response.status === 400) {
            setIsApiError(true);
            return false;
          };
          return false;
        });
      return true;
    },
    next: () => {
      scrollTop();
      updateState();
      dispatch({
        type: CHANGE_VALID,
        path,
        valid,
      });
    },
  };
  return isSp ? (
    <PresentSP
      howToDo={howToDo}
      workInfoDips={workInfoDips}
      workConditionsDisp={workConditionsDisp}
      howToDoAreaDisp={howToDoAreaDisp}
      floatingBannerDisp={floatingBannerDisp}
      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      selectedDate={
        desiredStartDate ? new Date(desiredStartDate) : desiredStartDate
      }
      valid={valid}
      showLoading={showLoading}
    />
  ) : (
    <PresentPC
      howToDo={howToDo}
      workInfoDips={workInfoDips}
      workConditionsDisp={workConditionsDisp}
      howToDoAreaDisp={howToDoAreaDisp}
      floatingBannerDisp={floatingBannerDisp}
      onClickMainButton={onClickMainButton}
      isApiError={isApiError}
      selectedDate={
        desiredStartDate ? new Date(desiredStartDate) : desiredStartDate
      }
      valid={valid}
      returnTopDisp={returnTopDisp}
      workInfoRef={workInfoRef}
      workConditionsRef={workConditionsRef}
      showLoading={showLoading}
      handleScroll={handleScroll}
    />
  );
};

export default AddInput;
